import { http, HttpResponse } from 'msw';

import { ConsentDetailResponse } from '../../api/consent';

const kreditStatusConsent: ConsentDetailResponse = {
    id: '11111111-1111-1111-1111-111111111111',
    viewId: '22222222-2222-2222-2222-222222222222',
    displayType: 'CHECKBOX',
    label: 'Jeg giver samtykke til, at Resurs Bank indhenter oplysninger fra eSkat og KreditStatus',
    information:
        '<p>Samtykket bruges til at verificere din indkomst og dine kreditter, så vi kan behandle ansøgningen uden manuelle bilag.</p>',
    required: true,
};

/**
 * `GET {proxy}/application/consent/{consentType}` had no handler at all, and MSW is configured to
 * warn-and-passthrough on unhandled requests -- so in demo mode this call escaped to the real dev gateway.
 * Consent pages then rendered whatever that environment happened to return, which for DK
 * `TERMS_CREDIT_STATUS` is nothing until LP-2835/LP-2805/LP-2846 land. That left the consent happy path
 * untested at every tier.
 *
 * Deliberately scoped to `TERMS_CREDIT_STATUS` and no other type: the remaining types (`TERMS_LOANS`,
 * `TERMS_PPI`, `MARKETING_ELECTRONIC`, `MONTIO`) still reach the real service, which is what the NO demo and
 * e2e flows have always exercised. A catch-all returning an empty list would quietly empty the terms-consent
 * gate on the submit pages instead.
 *
 * Country-agnostic on purpose: `proxyBaseUrl` substitutes the real country code, and pinning `NO` into a mock
 * path is exactly the bug that makes DK demo mode silently miss `validateGovernmentIdHandlers` (LP-2867).
 */
export const getConsentsHandlers = [
    http.get('*/application/consent/TERMS_CREDIT_STATUS', () =>
        HttpResponse.json({ consentDetails: [kreditStatusConsent] }),
    ),
];
